import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import COOKIES from '~/constants/cookies';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import StaticContext from '~/context/common/StaticContext';
import BrowserCookies from '~/utilities/BrowserCookies';
import { logError } from '~/utilities/loggers';

export default function useTrackBrowserCookieIdMismatch() {
  const { browserCookieId: browserCookieIdFromServer, userAgent } =
    useContext(StaticContext);
  const trackEvent = useTrackEvent();

  useEffectOnce(() => {
    const browserCookieIdFromBrowser = BrowserCookies.get(
      COOKIES.browserCookieId
    );

    if (
      browserCookieIdFromServer === browserCookieIdFromBrowser ||
      browserCookieIdFromServer === 'default' // in case this is a stub/honeypot page view
    ) {
      return;
    }

    logError(new Error('Browser cookie ID mismatch'), {
      browser: browserCookieIdFromBrowser,
      server: browserCookieIdFromServer,
      userAgent
    });

    trackEvent('Browser cookie ID mismatch', {
      action: 'loaded',
      browser: browserCookieIdFromBrowser,
      server: browserCookieIdFromServer,
      userAgent
    });
  }, [browserCookieIdFromServer, trackEvent, userAgent]);
}
